import SkeletonPulse from './SkeletonPulse';

const TimelineSkeletonButton = () => {
  return <SkeletonPulse classname="size-10 rounded-md" />;
};

const TimelinePlaybackControls = () => {
  return (
    <div className="flex justify-between px-4">
      <div className="flex gap-2">
        <TimelineSkeletonButton />
        <TimelineSkeletonButton />
      </div>
      <div className="flex items-center gap-2">
        <TimelineSkeletonButton />
        <TimelineSkeletonButton />
        <TimelineSkeletonButton />
        <SkeletonPulse classname="ml-2 w-20 h-4" />
        /
        <SkeletonPulse classname="w-20 h-4" />
      </div>
      <div className="flex gap-2">
        <SkeletonPulse classname="size-6 rounded-md" />
        <SkeletonPulse classname="h-6 w-32 rounded-md" />
        <SkeletonPulse classname="size-6 rounded-md" />
        <SkeletonPulse classname="size-6 rounded-md" />
      </div>
    </div>
  );
};

const SpeakerTimeline = () => {
  return (
    <div className="flex flex-1 flex-col">
      <div className="flex h-full flex-1 items-center gap-4">
        <TimelineSkeletonButton />
        <SkeletonPulse classname="flex-1 rounded-md h-full" />
        <TimelineSkeletonButton />
      </div>
    </div>
  );
};

const TimelineSkeleton = () => {
  return (
    <div className="flex size-full flex-col gap-2 rounded-lg bg-white p-3">
      <TimelinePlaybackControls />
      <SpeakerTimeline />
    </div>
  );
};

export default TimelineSkeleton;
